import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e6763c6")

_pushScopeId("data-v-1e6763c6")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "fa fa-envelope" }, null, -1)
const _hoisted_2 = { class: "p-m-4" }
const _hoisted_3 = {
  key: 0,
  class: "pi pi-exclamation-triangle kn-warning-icon",
  "data-test": "warning-icon"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-m-4" }
const _hoisted_6 = {
  key: 0,
  class: "p-m-4"
}
const _hoisted_7 = { class: "kn-material-input-label" }
const _hoisted_8 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_9 = { class: "max-length-help p-m-0" }
const _hoisted_10 = {
  key: 1,
  class: "p-m-4"
}
const _hoisted_11 = { class: "p-my-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "kn-material-input-label" }
const _hoisted_14 = { class: "p-my-2" }
const _hoisted_15 = { class: "kn-material-input-label" }
const _hoisted_16 = { class: "p-m-4" }
const _hoisted_17 = {
  key: 2,
  class: "p-m-4"
}
const _hoisted_18 = { class: "kn-material-input-label" }
const _hoisted_19 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_20 = { class: "max-length-help p-m-0" }
const _hoisted_21 = { class: "p-m-4" }
const _hoisted_22 = { class: "p-m-4" }
const _hoisted_23 = {
  key: 3,
  class: "p-m-4"
}
const _hoisted_24 = { class: "kn-material-input-label" }
const _hoisted_25 = { class: "p-d-flex p-jc-end" }
const _hoisted_26 = { class: "p-m-4" }
const _hoisted_27 = { class: "p-m-4" }
const _hoisted_28 = { class: "kn-material-input-label" }
const _hoisted_29 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_30 = { class: "max-length-help p-m-0" }
const _hoisted_31 = { class: "p-m-4" }
const _hoisted_32 = { class: "kn-material-input-label" }
const _hoisted_33 = { class: "p-d-flex p-jc-end" }
const _hoisted_34 = { class: "p-m-4" }
const _hoisted_35 = { class: "kn-material-input-label" }
const _hoisted_36 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_37 = { class: "max-length-help p-m-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Message = _resolveComponent("Message")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Accordion, { activeIndex: 0 }, {
    default: _withId(() => [
      _createVNode(_component_AccordionTab, null, {
        header: _withId(() => [
          _hoisted_1,
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('managers.scheduler.sendMail')), 1),
          (_ctx.document.invalid?.invalidMail)
            ? (_openBlock(), _createBlock("i", _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        default: _withId(() => [
          (_ctx.document)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _withDirectives(_createVNode(_component_Message, {
                  class: "p-m-4 p-p-1",
                  severity: "info",
                  closable: false
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.uniqueMailSelectedInfo')), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.uniqueMailEnabledOnOtherDocument]
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.document.useFixedRecipients,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.document.useFixedRecipients = $event)),
                    binary: true,
                    onChange: _ctx.removeDocumentExpressionAndDatasets
                  }, null, 8, ["modelValue", "onChange"]),
                  _withDirectives(_createVNode("span", { class: "p-ml-2" }, _toDisplayString(_ctx.$t('managers.scheduler.fixedRecipientsList')), 513), [
                    [
                      _directive_tooltip,
                      _ctx.$t('managers.scheduler.fixedRecipientsListHelp'),
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                (_ctx.document.useFixedRecipients)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("span", null, [
                        _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.scheduler.mailTo')) + " " + _toDisplayString(_ctx.uniqueMailEnabledOnOtherDocument ? ' ' : '*'), 1),
                        _createVNode(_component_InputText, {
                          class: ["kn-material-input p-inputtext-sm", {
                                'p-invalid': _ctx.fixedRecipientsListDirty && (!_ctx.document.mailtos || _ctx.document.mailtos.length === 0) && !_ctx.uniqueMailEnabledOnOtherDocument
                            }],
                          modelValue: _ctx.document.mailtos,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.document.mailtos = $event)),
                          maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.mail.mailToMaxLength,
                          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateDocument('fixedRecipientsListDirty'))),
                          onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateDocument('fixedRecipientsListDirty')))
                        }, null, 8, ["modelValue", "class", "maxLength"])
                      ]),
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", null, [
                          _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-4" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('managers.scheduler.fixedRecipientsList') })), 513), [
                            [_vShow, _ctx.fixedRecipientsListDirty && (!_ctx.document.mailtos || _ctx.document.mailtos.length === 0)]
                          ])
                        ]),
                        _createVNode("p", _hoisted_9, _toDisplayString(_ctx.mailToHelp), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.drivers.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _createVNode(_component_Checkbox, {
                          modelValue: _ctx.document.useDataset,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.document.useDataset = $event)),
                          binary: true,
                          onChange: _ctx.removeDocumentFixedRecipientsAndExpression
                        }, null, 8, ["modelValue", "onChange"]),
                        _withDirectives(_createVNode("span", {
                          class: "p-ml-2",
                          innerHTML: _ctx.$t('managers.scheduler.useDatasetList')
                        }, null, 8, ["innerHTML"]), [
                          [
                            _directive_tooltip,
                            _ctx.$t('managers.scheduler.useDatasetListHelp'),
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]),
                      (_ctx.document.useDataset)
                        ? (_openBlock(), _createBlock("div", _hoisted_12, [
                            _createVNode("div", null, [
                              _createVNode("span", null, [
                                _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.scheduler.datasetVerification')) + " " + _toDisplayString(_ctx.uniqueMailEnabledOnOtherDocument ? ' ' : '*'), 1),
                                _createVNode(_component_Dropdown, {
                                  class: ["kn-material-input", {
                                        'p-invalid': _ctx.datasetLabelDirty && (!_ctx.document.datasetLabel || _ctx.document.datasetLabel?.length === 0) && !_ctx.uniqueMailEnabledOnOtherDocument
                                    }],
                                  modelValue: _ctx.document.datasetLabel,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.document.datasetLabel = $event)),
                                  options: _ctx.datasets,
                                  optionLabel: "label",
                                  optionValue: "label",
                                  filter: true,
                                  filterMatchMode: "contains",
                                  filterFields: ['label'],
                                  onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateDocument('datasetLabelDirty'))),
                                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateDocument('datasetLabelDirty')))
                                }, null, 8, ["modelValue", "class", "options"]),
                                _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-4" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('managers.scheduler.datasetVerification') })), 513), [
                                  [_vShow, _ctx.datasetLabelDirty && (!_ctx.document.datasetLabel || _ctx.document.datasetLabel?.length === 0)]
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_14, [
                              _createVNode("span", null, [
                                _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('common.parameter')) + " " + _toDisplayString(_ctx.uniqueMailEnabledOnOtherDocument ? ' ' : '*'), 1),
                                _createVNode(_component_Dropdown, {
                                  class: ["kn-material-input", {
                                        'p-invalid': _ctx.datasetParameterDirty && (!_ctx.document.datasetParameter || _ctx.document.datasetParameter?.length === 0) && !_ctx.uniqueMailEnabledOnOtherDocument
                                    }],
                                  modelValue: _ctx.document.datasetParameter,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.document.datasetParameter = $event)),
                                  options: _ctx.drivers,
                                  onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.validateDocument('datasetParameterDirty'))),
                                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateDocument('datasetParameterDirty')))
                                }, null, 8, ["modelValue", "class", "options"]),
                                _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-4" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.parameter') })), 513), [
                                  [_vShow, _ctx.datasetParameterDirty && (!_ctx.document.datasetParameter || _ctx.document.datasetParameter?.length === 0)]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.document.useExpression,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.document.useExpression = $event)),
                    binary: true,
                    onChange: _ctx.removeDocumentFixedRecipientsAndDatasets
                  }, null, 8, ["modelValue", "onChange"]),
                  _withDirectives(_createVNode("span", {
                    class: "p-ml-2",
                    innerHTML: _ctx.$t('managers.scheduler.useExpression')
                  }, null, 8, ["innerHTML"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('managers.scheduler.useExpressionHelp'),
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                (_ctx.document.useExpression)
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _createVNode("span", null, [
                        _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('managers.scheduler.expression')) + " " + _toDisplayString(_ctx.uniqueMailEnabledOnOtherDocument ? ' ' : '*'), 1),
                        _createVNode(_component_InputText, {
                          class: ["kn-material-input p-inputtext-sm", {
                                'p-invalid': _ctx.expressionDirty && (!_ctx.document.expression || _ctx.document.expression.length === 0) && !_ctx.uniqueMailEnabledOnOtherDocument
                            }],
                          modelValue: _ctx.document.expression,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.document.expression = $event)),
                          maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.mail.expressionMaxLength,
                          onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.validateDocument('expressionDirty'))),
                          onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.validateDocument('expressionDirty')))
                        }, null, 8, ["modelValue", "class", "maxLength"])
                      ]),
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", null, [
                          _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-4" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('managers.scheduler.expression') })), 513), [
                            [_vShow, _ctx.expressionDirty && (!_ctx.document.expression || _ctx.document.expression.length === 0)]
                          ])
                        ]),
                        _createVNode("p", _hoisted_20, _toDisplayString(_ctx.expresionHelp), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("div", _hoisted_21, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.document.uniqueMail,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.document.uniqueMail = $event)),
                    binary: true,
                    onChange: _ctx.onSendUniqueMailChanged
                  }, null, 8, ["modelValue", "onChange"]),
                  _createVNode("span", {
                    class: "p-ml-2",
                    innerHTML: _ctx.$t('managers.scheduler.uniqueMail')
                  }, null, 8, ["innerHTML"])
                ], 512), [
                  [_vShow, !_ctx.uniqueMailEnabledOnOtherDocument]
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.document.zipMailDocument,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.document.zipMailDocument = $event)),
                    binary: true,
                    onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validateDocument(null)))
                  }, null, 8, ["modelValue"]),
                  _createVNode("span", {
                    class: "p-ml-2",
                    innerHTML: _ctx.$t('managers.scheduler.zipMailDocument')
                  }, null, 8, ["innerHTML"])
                ]),
                (_ctx.document.zipMailDocument)
                  ? (_openBlock(), _createBlock("div", _hoisted_23, [
                      _createVNode("span", null, [
                        _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('managers.scheduler.zipFileName')), 1),
                        _createVNode(_component_InputText, {
                          class: "kn-material-input p-inputtext-sm",
                          modelValue: _ctx.document.zipMailName,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.document.zipMailName = $event)),
                          maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.mail.zipMailNameMaxLength,
                          onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.validateDocument(null)))
                        }, null, 8, ["modelValue", "maxLength"])
                      ]),
                      _createVNode("div", _hoisted_25, [
                        _createVNode("small", null, _toDisplayString(_ctx.zipMailNameHelp), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_26, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.document.reportNameInSubject,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.document.reportNameInSubject = $event)),
                    binary: true,
                    onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validateDocument(null)))
                  }, null, 8, ["modelValue"]),
                  _createVNode("span", {
                    class: "p-ml-2",
                    innerHTML: _ctx.$t('managers.scheduler.reportNameInSubject')
                  }, null, 8, ["innerHTML"])
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("span", null, [
                    _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('managers.scheduler.mailSubject')), 1),
                    _createVNode(_component_InputText, {
                      class: "kn-material-input p-inputtext-sm",
                      modelValue: _ctx.document.mailsubj,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.document.mailsubj = $event)),
                      maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.mail.mailSubjectMaxLength,
                      onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.validateDocument(null)))
                    }, null, 8, ["modelValue", "maxLength"])
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _createVNode("p", _hoisted_30, _toDisplayString(_ctx.mailSubjectHelp), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("span", null, [
                    _createVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('common.fileName')), 1),
                    _createVNode(_component_InputText, {
                      class: "kn-material-input p-inputtext-sm",
                      modelValue: _ctx.document.containedFileName,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.document.containedFileName = $event)),
                      maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.mail.fileNameMaxLength,
                      onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.validateDocument(null)))
                    }, null, 8, ["modelValue", "maxLength"])
                  ]),
                  _createVNode("div", _hoisted_33, [
                    _createVNode("small", null, _toDisplayString(_ctx.fileNameHelp), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_34, [
                  _createVNode("span", null, [
                    _createVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('managers.scheduler.mailText')), 1),
                    _createVNode(_component_InputText, {
                      class: "kn-material-input p-inputtext-sm",
                      modelValue: _ctx.document.mailtxt,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.document.mailtxt = $event)),
                      maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.mail.mailTextMaxLength,
                      placeholder: _ctx.$t('managers.scheduler.mailTextMessage'),
                      onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.validateDocument(null)))
                    }, null, 8, ["modelValue", "maxLength", "placeholder"])
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _createVNode("p", _hoisted_37, _toDisplayString(_ctx.mailTextHelp), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})